/**
 * Бизнес-модель. Соответствует словарю tariff_model_type
 * @prop  COMMON = 1, // Обычный
 * @prop  PACKET = 2, // Пакетный
 */

export enum TariffModelTypes {
  COMMON = 1, // Обычный
  PACKET = 2, // Пакетный
}
